import React from 'react'
import { connect } from 'react-redux'

import * as actionCreators from '../../../../store/actions'
import { mapStateToProps } from '../../../../utils'
import { GenericFilter } from './genericFilter'

const classNames = require('classnames')

export class NumberFilter extends GenericFilter {
  composeValue = e => {
    const container = e.target.closest('.number-field')
    const inputList = container.querySelectorAll('input[type=number]')
    const updatedFieldArrayValue = []

    for (let i = 0; i !== 2; i += 1) {
      const dateValue = inputList[i].value
      if (dateValue) {
        updatedFieldArrayValue.push(dateValue)
      }
    }

    this.updateFilter(updatedFieldArrayValue.join(','))
  }

  renderFilter = () => {
    const { filter, environment, specialization } = this.props
    const { filterValue } = this.state

    const { locale } = environment
    const { translations } = specialization
    const { texts } = translations

    const parsedFilterValue = filterValue ? filterValue.split(',') : []

    const html = []
    html.push(
      <div
        key={`filter_${filter.label}`}
        className={classNames('number-field')}
      >
        <input
          type="number"
          placeholder={texts[locale].from || 'from'}
          className={classNames('form-control rounded-4 shadow-sm border-0')}
          defaultValue={parsedFilterValue[0] || ''}
          onBlur={e => {
            this.composeValue(e)
          }}
        />
        <input
          type="number"
          placeholder={texts[locale].to || 'to'}
          className={classNames(
            'form-control rounded-4 shadow-sm border-0 mt-2'
          )}
          defaultValue={parsedFilterValue[1] || ''}
          onBlur={e => {
            this.composeValue(e)
          }}
        />
      </div>
    )
    return html
  }
}

export default connect(mapStateToProps, actionCreators)(NumberFilter)
